import React, { useEffect, useState } from 'react';
import { useIntl, useParams } from 'umi';
import classNames from 'classnames';
import { LANGUAGE_EN } from '@home/_config/config';
import SvgIcon from '@home/components/SvgIcon';
import { getName } from '@home/utils/common';
import { getCommonApi } from '@home/services/studio';
import CommonBubble from '@home/components/CommonBubble';
import { IChangeLogProps } from './type';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';
import './index.scss';

const ChangeLog = (props: IChangeLogProps) => {
  const {
    className,
    style,
    expandStyle,
    buttonTextEn = 'Change Log',
    buttonTextCn = '更改日志',
    api = '',
    extraParams,
    noDataTextEn = 'No change logs',
    noDataTextCn = '无更改日志',
    cacheName = '__dbh_home_kpi_change_log_update_time',
  } = props || {};

  const [visible, setVisible] = useState(false);
  const [contentLogEn, setContentLogEn] = useState('');
  const [contentLogCn, setContentLogCn] = useState('');
  const [updateTime, setUpdateTime] = useState('');
  const [error, setError] = useState(false);
  const [nodata, setNodata] = useState(false);

  const { formatMessage } = useIntl();
  const { studioId } = useParams() || ({} as any);

  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const buttonText = getName(isEn, buttonTextEn, buttonTextCn);
  const noDataText = getName(isEn, noDataTextEn, noDataTextCn);
  const contentLog = getName(isEn, contentLogEn, contentLogCn);

  // 关闭的时候才缓存记录数据
  const closeLog = () => {
    localStorage.setItem(cacheName, updateTime);
    setVisible(false);
  };

  useEffect(() => {
    getCommonApi({ studio_code: studioId, ...(extraParams || {}) }, api)
      .then((res: any) => {
        const { change_log, update_time, change_log_cn } = res || {};
        setContentLogEn(change_log);
        setContentLogCn(change_log_cn);
        setUpdateTime(update_time);
        if (change_log || change_log_cn) {
          // 1. 本地没缓存，显示记录
          // 2. 本地有缓存，比较更新时间，如果更新时间不一致，显示记录
          const updateTime = localStorage.getItem(cacheName);
          if (!updateTime) {
            setVisible(true);
          } else if (updateTime !== update_time) {
            setVisible(true);
          }
        } else {
          setNodata(true);
        }
      })
      .catch((err) => {
        console.log('★ ~ ChangeLogApi ~ err>>', err);
        setError(true);
      });
  }, [api, cacheName, extraParams, studioId]);

  return (
    <div
      className={classNames('dbh-kpi-change-log-container', className)}
      style={(!visible && expandStyle) ? expandStyle : style}
    >
      <CommonBubble content={nodata ? noDataText : null}>
        <div
          className={classNames('dbh-kpi-change-log-button')}
          onClick={() => {
            if (!nodata) {
              setVisible(!visible);
            }
          }}
        >
          <SvgIcon type="hint-new" />
          <div className="dbh-kpi-change-log-button-text">{buttonText}</div>
        </div>
      </CommonBubble>
      {visible && (
        <div className="dbh-kpi-change-log-content">
          <FormatHtmlTextToReact
            className="dbh-kpi-change-log-content-text"
            text={
              error
                ? formatMessage({ id: 'common_loading_failed' })
                : contentLog
            }
          />
          <div className="dbh-kpi-change-log-triangle"></div>
          <i className="dbh-kpi-change-log-close-icon" onClick={closeLog}>
            <SvgIcon type="clonse" />
          </i>
        </div>
      )}
    </div>
  );
};

export default ChangeLog;
